/**
 * Контакты поддержки фирмы (K-0049): у фирмы НЕТ телефона для звонков.
 * Связь — WhatsApp (главный канал) и почта. Номер лежит в
 * `system_config/support` → `{ whatsapp: '9725XXXXXXXX', email }`, чтобы его
 * можно было поменять без релиза. Пока номер не заполнен — кнопка WhatsApp
 * не показывается, остаётся почта.
 */
'use client';
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase/client';

export const SUPPORT_EMAIL = 'support@yofiplace.co.il';

export function useSupportContact(): { whatsapp: string; email: string; loading: boolean } {
  const [whatsapp, setWhatsapp] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'system_config', 'support'));
        const raw = snap.exists() ? snap.data()?.whatsapp : '';
        const digits = typeof raw === 'string' ? raw.replace(/\D/g, '') : '';
        if (mounted && digits.length >= 11) setWhatsapp(digits);
      } catch {
        // нет конфига — показываем только почту
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);
  return { whatsapp, email: SUPPORT_EMAIL, loading };
}

/** wa.me-ссылка с заготовленным текстом. */
export function waLink(number: string, text: string): string {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
